import i from "./index49.js";
import A from "./index74.js";
import { sanitizeHeaderValue as h } from "./index75.js";
const S = Symbol("internals");
function y(o) {
  return o && String(o).trim().toLowerCase();
}
function m(o) {
  return o === !1 || o == null ? o : i.isArray(o) ? o.map(m) : h(String(o));
}
function j(o) {
  const t = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = e.exec(o); )
    t[s[1]] = s[2];
  return t;
}
const k = (o) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(o.trim());
function b(o, t, e, s, n) {
  if (i.isFunction(s))
    return s.call(this, t, e);
  if (n && (t = e), !!i.isString(t)) {
    if (i.isString(s))
      return t.indexOf(s) !== -1;
    if (i.isRegExp(s))
      return s.test(t);
  }
}
function H(o) {
  return o.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, e, s) => e.toUpperCase() + s);
}
function d(o, t) {
  const e = i.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(o, s + e, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(n, r, f) {
        return this[s].call(this, t, n, r, f);
      },
      configurable: !0
    });
  });
}
class g {
  constructor(t) {
    t && this.set(t);
  }
  set(t, e, s) {
    const n = this;
    function r(c, a, u) {
      const l = y(a);
      if (!l)
        return;
      const p = i.findKey(n, l);
      (!p || n[p] === void 0 || u === !0 || u === void 0 && n[p] !== !1) && (n[p || a] = m(c));
    }
    const f = (c, a) => i.forEach(c, (u, l) => r(u, l, a));
    if (i.isPlainObject(t) || t instanceof this.constructor)
      f(t, e);
    else if (i.isString(t) && (t = t.trim()) && !k(t))
      f(A(t), e);
    else if (i.isObject(t) && i.isSafeIterable(t)) {
      let c = /* @__PURE__ */ Object.create(null), a, u;
      for (const l of t) {
        if (!i.isArray(l))
          throw new TypeError("Object iterator must return a key-value pair");
        u = l[0], i.hasOwnProp(c, u) ? (a = c[u], c[u] = i.isArray(a) ? [...a, l[1]] : [a, l[1]]) : c[u] = l[1];
      }
      f(c, e);
    } else
      t != null && r(e, t, s);
    return this;
  }
  get(t, e) {
    if (t = y(t), t) {
      const s = i.findKey(this, t);
      if (s) {
        const n = this[s];
        if (!e)
          return n;
        if (e === !0)
          return j(n);
        if (i.isFunction(e))
          return e.call(this, n, s);
        if (i.isRegExp(e))
          return e.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, e) {
    if (t = y(t), t) {
      const s = i.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!e || b(this, this[s], s, e)));
    }
    return !1;
  }
  delete(t, e) {
    const s = this;
    let n = !1;
    function r(f) {
      if (f = y(f), f) {
        const c = i.findKey(s, f);
        c && (!e || b(s, s[c], c, e)) && (delete s[c], n = !0);
      }
    }
    return i.isArray(t) ? t.forEach(r) : r(t), n;
  }
  clear(t) {
    const e = Object.keys(this);
    let s = e.length, n = !1;
    for (; s--; ) {
      const r = e[s];
      (!t || b(this, this[r], r, t, !0)) && (delete this[r], n = !0);
    }
    return n;
  }
  normalize(t) {
    const e = this, s = {};
    return i.forEach(this, (n, r) => {
      const f = i.findKey(s, r);
      if (f) {
        e[f] = m(n), delete e[r];
        return;
      }
      const c = t ? H(r) : String(r).trim();
      c !== r && delete e[r], e[c] = m(n), s[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const e = /* @__PURE__ */ Object.create(null);
    return i.forEach(this, (s, n) => {
      s != null && s !== !1 && (e[n] = t && i.isArray(s) ? s.join(", ") : s);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, e]) => t + ": " + e).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...e) {
    const s = new this(t);
    return e.forEach((n) => s.set(n)), s;
  }
  static accessor(t) {
    const s = (this[S] = this[S] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function r(f) {
      const c = y(f);
      s[c] || (d(n, f), s[c] = !0);
    }
    return i.isArray(t) ? t.forEach(r) : r(t), this;
  }
}
g.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
i.reduceDescriptors(g.prototype, ({ value: o }, t) => {
  let e = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => o,
    set(s) {
      this[e] = s;
    }
  };
});
i.freezeMethods(g);
const w = g;
export {
  w as default
};
